<template>
	<section id="number" class="w-100 py-0">
		<b-row class="pt-3 pt-lg-5" v-view="viewHandler">
			<b-col cols="12" lg="6" xl="5" class="col-xxl-4 text-center mx-auto viewer fade pt-4">
				<h3 class="pb-3 pb-lg-5">
					<span v-if="$creo.getLang() == 'sv'">Stark försäljning och <nobr>stabil nivå produktionsstarter</nobr></span>
					<span v-else>Strong sales and <nobr>stable level of housing starts</nobr></span>
				</h3>
			</b-col>
		</b-row>
		<b-row class="pt-3 py-lg-4">
			<b-col cols="12" lg="10" offset-lg="1" class="px-5">
				<b-row  id="briefNumbers" v-view="viewHandler">
					<b-col cols="6" lg="4" class="text-center viewer fade">
						<div class="text-orange text-nowrap display-1 font-weight-ultra-light">
							<c-count-up :endVal="15388"
										:delay="500"
										:show="showNumbers" />
						</div>
						<p class="pb-3 pb-lg-5 small">
							<span v-if="$creo.getLang() == 'sv'">Intäkter, mkr</span>
							<span v-else>Revenue SEK m</span>
						</p>
					</b-col>
					<b-col cols="6" lg="4" class="text-center viewer fade">
						<div class="text-orange text-nowrap display-1 font-weight-ultra-light">
							<c-count-up :endVal="1955"
										:delay="500"
										:show="showNumbers" />
						</div>
						<p class="pb-3 pb-lg-5 small">
							<span v-if="$creo.getLang() == 'sv'">Resultat före skatt, mkr</span>
							<span v-else>Profit before tax, SEK m</span>
						</p>
					</b-col>
					<b-col cols="6" lg="4" class="text-center viewer fade">
						<div class="text-orange text-nowrap display-1 font-weight-ultra-light">
							<c-count-up :endVal="1715"
										:delay="500"
										:show="showNumbers" />
						</div>
						<p class="pb-3 pb-lg-5 small">
							<span v-if="$creo.getLang() == 'sv'">Koncernens kassaflöde, mkr</span>
							<span v-else>Consolidated cash flow, SEK m</span>
						</p>
					</b-col>
					<b-col cols="6" lg="4" class="text-center viewer fade">
						<div class="text-orange text-nowrap display-1 font-weight-ultra-light">
							<c-count-up :endVal="2028"
										:delay="500"
										:show="showNumbers" />
						</div>
						<p class="pb-3 pb-lg-5 small">
							<span v-if="$creo.getLang() == 'sv'">Rörelseresultat, mkr</span>
							<span v-else>Operating profit, SEK m</span>
						</p>
					</b-col>
					<b-col cols="6" lg="4" class="text-center viewer fade">
						<div class="text-orange text-nowrap display-1 font-weight-ultra-light">
							<c-count-up :endVal="20.8"
										:decimals="1"
										:delay="500"
										:suffix="'%'"
										:show="showNumbers" />
						</div>
						<p class="pb-3 pb-lg-5 small">
							<span v-if="$creo.getLang() == 'sv'">Räntabilitet eget kapital</span>
							<span v-else>Return of equity</span>
						</p>
					</b-col>
					<b-col cols="6" lg="4" class="text-center viewer fade">
						<div class="text-orange text-nowrap display-1 font-weight-ultra-light">
							<c-count-up :endVal="4026"
										:delay="500"
										:show="showNumbers" />
						</div>
						<p class="pb-3 pb-lg-5 small">
							<span v-if="$creo.getLang() == 'sv'">Antal sålda bostäder</span>
							<span v-else>Number of residential units sold</span>
						</p>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
		<b-row v-view="viewHandler" class="pb-4 pb-lg-5">
			<b-col cols="12" class="text-center viewer fade">
				<a 	:href="$creo.browserPdfLink(pdfLink.org[$creo.getLang()], pdfLink.fallback[$creo.getLang()], pdfLink.page[$creo.getLang()])"
					target="_blank"
					class="btn btn-link pt-3 italic text-decoration-none standard-white">
					<span v-if="$creo.getLang() == 'sv'">Läs mer</span>
					<span v-else>Read more</span><span class="ml-2 arrow-gray float-right"></span>
				</a>
			</b-col>
		</b-row>
	</section>
</template>
<script>
	import CCountUp from '@/components/CountUp.vue'
	export default {
		props: {
			pdfLink: Object
		},
		components: {
			CCountUp
		},
		data() {
			return {
				showNumbers: false
			}
		},
		methods: {
			viewHandler(e) {
				const status = e.type
				const id = e.target.element.id
				if(status === 'enter' && id === 'briefNumbers' || status === 'progress' && id === 'briefNumbers') {
					this.showNumbers = true
				} else if(status === 'exit' && id === 'briefNumbers') {
					this.showNumbers = false
				}
			}
		}
	}
</script>
